import { render, staticRenderFns } from "./LoadingBanner.vue?vue&type=template&id=5c212d7c&scoped=true"
import script from "./LoadingBanner.vue?vue&type=script&lang=js"
export * from "./LoadingBanner.vue?vue&type=script&lang=js"
import style0 from "./LoadingBanner.vue?vue&type=style&index=0&id=5c212d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c212d7c",
  null
  
)

export default component.exports